import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import { CameraAlt, Close, Add } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
export const LogoUpload = ({ value, onChange, size = 96, label }) => {
    const { t } = useTranslation();
    const fileInputRef = React.useRef(null);
    const handleLogoClick = () => {
        fileInputRef.current?.click();
    };
    const handleLogoChange = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            // Validate file type
            if (!file.type.startsWith('image/')) {
                toast.error('Please select an image file');
                return;
            }
            // Validate file size (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                toast.error('Image size should be less than 5MB');
                return;
            }
            // Create preview URL
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                // Remove data:image/png;base64, prefix to get pure base64 string
                const pureBase64 = base64String.split(',')[1] || base64String;
                onChange(pureBase64);
            };
            reader.readAsDataURL(file);
        }
    };
    const removeLogo = (e) => {
        e.stopPropagation();
        onChange(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    return (_jsxs(Box, { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, py: 2, children: [_jsx("input", { type: 'file', ref: fileInputRef, onChange: handleLogoChange, accept: 'image/*', style: { display: 'none' } }), _jsxs(Box, { position: 'relative', children: [_jsx(Avatar, { sx: {
                            width: size,
                            height: size,
                            bgcolor: 'light'
                        }, src: value
                            ? value.startsWith('blob:') || value.startsWith('http')
                                ? value // Blob URL or HTTP URL from backend
                                : `data:image/png;base64,${value}` // Base64 string from new upload
                            : undefined, slotProps: {
                            img: {
                                crossOrigin: 'anonymous'
                            }
                        }, children: _jsx(CameraAlt, { sx: { fontSize: size * 0.625 } }) }), !value && (_jsx(IconButton, { size: 'small', onClick: handleLogoClick, sx: {
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                            bgcolor: 'background.paper',
                            color: 'grey.600',
                            border: 1,
                            borderColor: 'grey.400',
                            borderRadius: 1,
                            '&:hover': {
                                bgcolor: 'grey.100'
                            }
                        }, children: _jsx(Add, { fontSize: 'small' }) })), value && (_jsx(IconButton, { size: 'small', onClick: removeLogo, sx: {
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            bgcolor: 'error.main',
                            color: 'white',
                            '&:hover': {
                                bgcolor: 'error.dark'
                            }
                        }, children: _jsx(Close, { fontSize: 'small' }) }))] }), _jsx(Typography, { variant: 'caption', color: 'text.secondary', children: label || t('logo') })] }));
};
